import { createReducer, createAction } from '@reduxjs/toolkit'

/// tipi 

export interface AjaxAutocompleteObject {
    id: string
    value: string
}

export interface Person {
    id?: number | string
    email?: string
    phone?: string

    gender?: string
    name?: string
    surname?: string
    dateOfBirth?: Date
    
    bornInItaly?: boolean
    cityOfBirth?: AjaxAutocompleteObject
    countryOfBirth?: AjaxAutocompleteObject

    countryOfResidence?: AjaxAutocompleteObject
    cityOfResidence?: AjaxAutocompleteObject
    postalCodeOfResidence?: string
    address?: string
    addressNumber?: string
    addressToponimo?: string

    civilState?: string
    
    /*
    possibili valori di children
    
    [1,2] rispettivamente figli minorenni e maggiorenni
    [1] figli minorenni
    [2] figli maggiorenni
    [0] nessun figlio
    */
    children?: number[]
    childrenAsString?: string
    youngestChild?: number | string
    
    degree?: string
    profession?: string

    italianDrivingLicense?: boolean    
    drivingLicenseAge?: number
    drivingLicenceType?: string
    drivingLicencePoints?: number,
    drivingLicenceSuspensions?: number
    drivingLicenceSuspensionMonths?: number
    drunkDrivingTickets?: number

    errors?: any[] | undefined

    created_at?: string
    updated_at?: string
}

export interface Vehicle {
    id?: number | string
    vehicleName?: string | undefined
    vehicleType?: string
    vehicleOwned?: boolean
    vehicleLicensePlateNumber?: string
    vehicleBuyYear?: number
    vehicleRegistrationMonth?: number
    vehicleRegistrationYear?: number
    vehicleBrand?: string
    vehicleBrandLabel?: string
    vehicleModel?: string
    vehicleModelLabel?: string
    vehicleFuelType?: string
    vehicleEngineDisplacement?: string
    vehicleFitting?: string
    vehicleFittingLabel?: string
    veicleFullDescription?: string
    vehicleAntitheft?: string
    vehicleTowbarMounted?: boolean
    vehicleGplMounted?: boolean

    created_at?: string
    updated_at?: string
}

export interface Company {
    id?: number | string
    legal_name?: string
    name?: string
    referent_first_name?: string
    referent_last_name?: string
    referent_email?: string
    referent_phone?: string
    registered_office_address?: string
    registered_office_cityOfResidence?: AjaxAutocompleteObject
    registered_office_addressNumber?: string
    registered_office_postalCode?: string
    vat?: string

    created_at?: string
    updated_at?: string
}

export interface PrivacyStatus {
    type: string
    consent: boolean
    channels: string[]
}


// nella risposta dello user service .. c è qualcosa di non serializzabile!
interface StoredUserInfo {
    id: number | string | undefined

    name: string | undefined
    surname: string | undefined

    email: string | undefined
    phone: string | undefined
    sf_account_id: string | undefined
}

export type UserType = StoredUserInfo & {
    
    userData: Person | undefined

    people: Person[] | undefined
    vehicles: Vehicle[] | undefined
    companies: Company[] | undefined
    privacy: PrivacyStatus[] | undefined

    created_at?: string
    updated_at?: string
}

export type ComponentStatus = {
    user: UserType | undefined
}

export const emptyComponentStatus : ComponentStatus = {
    user: undefined
}

/// reducer

export type Status = {
    user: StoredUserInfo
}

const initialStatus : Status = {
    user: {
        id: undefined,
        name: undefined,
        surname: undefined,
        email: undefined,
        phone: undefined,
        sf_account_id: undefined,
    }
}


export const componentStatusUpdate = createAction<Status>( 'status/update' )


export const componentStatusReducer = createReducer ( 
    initialStatus,
    (builder) => {
        builder.addCase(componentStatusUpdate, (state, action) => {
            return action.payload as Status
        })
    }
)